export const PROGRAM_SUBSCRIPTIONS_RESET_STATE = 'PROGRAM_SUBSCRIPTIONS_RESET_STATE';
export const PROGRAM_SUBSCRIPTIONS_CURRENT_ITEM = 'PROGRAM_SUBSCRIPTIONS_CURRENT_ITEM';

export const PROGRAM_SUBSCRIPTIONS_REQUEST_LOADING = 'PROGRAM_SUBSCRIPTIONS_REQUEST_LOADING';
export const PROGRAM_SUBSCRIPTIONS_REQUEST_SUCCESS = 'PROGRAM_SUBSCRIPTIONS_REQUEST_SUCCESS';
export const PROGRAM_SUBSCRIPTIONS_REQUEST_FAILED = 'PROGRAM_SUBSCRIPTIONS_REQUEST_FAILED';

export const PROGRAM_SUBSCRIPTIONS_CURRENT_ACTION = 'PROGRAM_SUBSCRIPTIONS_CURRENT_ACTION';
export const PROGRAM_SUBSCRIPTIONS_RESET_ACTION = 'PROGRAM_SUBSCRIPTIONS_RESET_ACTION';